"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKER = exports.FILER = exports.ATTORNEY = exports.ADMIN = void 0; // TODO: remove this file after Filer and Worker have been supplanted by User

exports.ADMIN = "admin";
exports.ATTORNEY = "attorney";
exports.FILER = "filer";
exports.WORKER = "worker";